import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get brand lsit
export const getBrandListApi = createAsyncThunk(
  "client/get-brand-list",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/brands/api/v1/get-brand-list`,
        data,
        {
          headers: {
            "auth-token": token,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("get brand list response", response.data);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching get-brand-list:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch get brand list"
      );
    }
  }
);
